(() => {
  const buttons = document.querySelectorAll('[data-wy-copy-link]');
  if (!buttons.length) return;

  buttons.forEach((link) => {
    link.addEventListener('click', async (event) => {
      const url = link.getAttribute('data-copy-url') || link.getAttribute('href');
      if (!url || !navigator.clipboard) return;

      event.preventDefault();
      try {
        await navigator.clipboard.writeText(url);
        const textEl = link.querySelector('.wy-article-share__text');
        const original = textEl ? textEl.textContent : link.textContent;
        if (textEl) {
          textEl.textContent = 'Link copied';
        } else {
          link.textContent = 'Link copied';
        }
        window.setTimeout(() => {
          if (textEl) {
            textEl.textContent = original;
          } else {
            link.textContent = original;
          }
        }, 1800);
      } catch (error) {
        // Keep the normal link behavior if clipboard is unavailable.
      }
    });
  });
})();
